var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4722 13.7408H2.89217C1.95517 13.7408 1.19617 12.9808 1.19617 12.0438V3.16084C1.19617 2.22384 1.95517 1.46484 2.89217 1.46484H16.4722C17.4092 1.46484 18.1692 2.22384 18.1692 3.16084V12.0438C18.1692 12.9808 17.4092 13.7408 16.4722 13.7408Z",
    stroke: "#93AFB9",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.31738 2.53911L8.26438 9.48611C8.94238 10.1641 10.0424 10.1641 10.7204 9.48611L17.9194 2.28711",
    stroke: "#93AFB9",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.2e0def9a922850368982ecaddccc9ec1.svg";
export { ForwardRef as ReactComponent };